module.exports = __webpack_public_path__ + "static/media/icon5.041e2e50.png";